module.exports = __webpack_public_path__ + "static/img/poster_3.7521241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/poster_3.jpg
// module id = YxfC
// module chunks = 0